export const inputCls =
    "w-full bg-white border border-slate-300 rounded-sm px-4 py-3 text-sm text-navy placeholder:text-slate-400 focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 transition-colors";

export const labelCls = "block text-xs uppercase tracking-wider font-semibold text-slate-600 mb-2";

export const Field = ({ label, required, error, children }) => (
    <div>
        <label className={labelCls}>
            {label} {required && <span className="text-brand">*</span>}
        </label>
        {children}
        {error && <p className="mt-1 text-xs text-red-600" data-testid="field-error">{error}</p>}
    </div>
);

// hidden honeypot field for spam protection
export const Honeypot = ({ register }) => (
    <input
        type="text"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        className="absolute left-[-9999px] w-0 h-0 opacity-0"
        {...register("honeypot")}
    />
);
